
import Vue from "vue";
const states = ["none", "ready", "go"] as const;
export type ReadyGoState = typeof states[number];

export default Vue.extend({
  name: "ReadyGo",
  computed: {
    message: function () {
      switch (this.$props.state) {
        case "none":
          return "";
        case "ready":
          return "Ready?";
        case "go":
          return "Go!!!";
        default:
          throw Error;
      }
    },
  },
  props: ["state"],
});
